import React, { useEffect, FC, useState } from "react";
import { YhFormBox } from "@/components/YhFormBoxVertical";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, ISelectOption } from "@/components/YhFormBoxVertical/Types";
import useNavModel, { } from "@/model/navModel";
import { useStockCheckDetailModel } from "./stockCheckDetailsModel";
import { DetailType } from "@/types/ScmEnums";
import useGlobalModel, { transOptions } from "@/model/globalModel";
import { Button, message } from "antd";
import { globalPrompt } from "@/components/message";
import { ITopType } from "@/types/ScmTypes";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import { debounce } from "lodash";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { useStockCheckModel } from "../../stockCheckModel";
import { IVRMshelfDetail } from "@/views/base/warehouse/warehouseTypes";
import { warehouseService } from "@/views/base/warehouse/warehouseService";
import { YHDetailNav } from "@/components/YHDetailNav";

export const FormBox: FC<ITopType> = ({ id, mode, IFormRef }) => {
    const { selectedNavId, findNav, replaceNav } = useNavModel();
    const [shelfList, setShelfList] = useState<IVRMshelfDetail[]>([]);
    const { getTreeNodeName } = useDictModel();

    const {
        loadData,
    } = useStockCheckModel();
    const { getSelectedDictOne } = useDictModel();
    const {
        detailAddForm,
        detailLookForm,
        detailEditForm,
        addDesc, lookDesc, editDesc,
        updateAddFormVal,
        updatEditFormVal,
        getDetailEditOne,
        resetAddCatch,
        resetEditCatch,
        insertDetail,
        editDetail,
        onComplete,
        setDetailAddList,
        setDetailAddForm,
        setProfitAndLossForm,
        onFinalAudit,
        saveLoading, setSaveLoading
    } = useStockCheckDetailModel();
    const { beShopDs, warehouseList, user: { username }, shopAndOrg: { shopId, shopCode, shopName } } = useGlobalModel()

    useEffect(() => {
        if (mode === DetailType.edit) {
            getDetailEditOne(id, mode).then(res => {
                if (res && res.warehouseCode) {
                    getShelfList(res.warehouseCode)
                }
            })
        }
        mode === DetailType.look && getDetailEditOne(id, mode).then(res => {
            if (res && res.warehouseCode) {
                getShelfList(res.warehouseCode)
            }
        })
        if (mode === DetailType.add) {
            if (detailAddForm && detailAddForm.warehouseCode) {
                getShelfList(detailAddForm.warehouseCode)
            }
        }
    }, [id, mode])
    useEffect(() => {
        return () => {
            !findNav("9-2-2") && resetAddCatch(mode);
            !findNav("9-2-3") && resetEditCatch(mode);
        }
    }, [selectedNavId])
    const save = () => {
        IFormRef.current?.validateFields().then(async res => {
            // return console.log(res)
            let params = {
                ...res,
                shelfCode: res.shelfCode.toString()
            }
            if (mode === "add") {
                const resData = await insertDetail(params)
                if (resData) {
                    globalPrompt("message", { text: "新增成功,跳转到编辑页面", type: "success" });
                    resetAddCatch(mode);
                    replaceNav("9-2-1", "9-2-2", { id: resData as string, mode: "edit" });
                    // goBack();
                }
            } else if (mode === "edit") {
                let { id, stocktakingCode } = detailEditForm
                const resData = await editDetail({ ...params, id })
                if (resData) {
                    globalPrompt("message", { text: "编辑成功", type: "success" });
                    resetEditCatch(mode);
                    getDetailEditOne(stocktakingCode as string, "edit")
                    // goBack();
                }
            }
        })
    }
    const Complete = async () => {
        let { stocktakingCode, id, status } = detailEditForm
        if (status === DictCodeEnmu.STOCKTAKING_COMPLETE) { return message.error("单据已完成，无法再次盘点") }
        if (status !== DictCodeEnmu.STOCKTAKING_CREATE) { return message.error("单据不是进行中状态，无法再次盘点") }
        let retData = await onComplete({ stocktakingCode, id })
        if (retData) {
            message.success("盘点成功")
            goBack()
        } else {
            message.error("盘点失败")
        }
    }
    const finalAudit = async () => {

        let { stocktakingCode, id, status } = detailEditForm
        if (status === DictCodeEnmu.STOCKTAKING_AUDIT) {
            globalPrompt("message", { text: "该单据已审核不可再审核", type: "error" })
            return
        }
        if (beShopDs.length == 0) {
            globalPrompt("message", { text: "本站点没有实体！", type: "error" })
            return
        }
        if (status != DictCodeEnmu.STOCKTAKING_COMPLETE) {
            globalPrompt("message", { text: "已完成的单据才可以进行审核", type: "error" })
            return
        }
        let retData = await onFinalAudit({
            stocktakingCode, id,
            bentityCode: beShopDs[0].value,
            bentityName: beShopDs[0].label,
        })
        if (retData) {
            message.success("审核成功")
            goBack()
        } else {
            message.error("审核失败")
        }
    }
    const goBack = () => {
        replaceNav(selectedNavId, "9-2")
    }
    const onRefresh = () => {
        IFormRef.current?.resetFields()
        setDetailAddList([]);
        setDetailAddForm({})
        // if (mode === "add") {
        //     IFormRef.current?.resetFields()
        //     resetAddCatch("add")
        // } else if (mode === "edit") {
        //     IFormRef.current?.resetFields()
        //     getDetailEditOne(id, mode)
        // }
        // message.success("刷新成功")
    }
    const rightChildren = <>
        <YhAuth resCode={ResourceAuthEnum.ST_STTAKE_ED_SAVE}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                loading={saveLoading}
                onClick={debounce(() => { save() }, 900)}
            >{saveLoading ? '保存中' : '保存'}</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.ST_STTAKE_ED_FINISH}>
            {mode === "edit" && <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={Complete}
            >盘点完成</Button>}
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.ST_STTAKE_ED_EXAMINE}>
            {mode === "edit" && <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={finalAudit}
            >审核</Button>}
        </YhAuth>
        {/* <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={onRefresh}
        >刷新</Button> */}
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={goBack}
        >返回</Button>
    </>
    const warehousChange = async (value: string, option: ISelectOption) => {
        option && onChange({ warehouseName: option.label, warehouseCode: option.value, shelfCode: [] });
        if (value) {
            getShelfList(value)
        }
    }
    const getShelfList = async (value: string) => {
        let params = {
            pageSize: 10000,
            pageNum: 1,
            warehouseCode: value,
        }
        const { retData } = await warehouseService.shelfAllPage(params)
        const newRecords = retData.map((item: IVRMshelfDetail) => { return { ...item, name: item.code } })
        setShelfList(newRecords)
    }
    const shelfCode = async (value: string, option: ISelectOption) => {
        console.log(value)
    }
    const baseFormItem: IYhFormItemsBox = {
        title: "基础信息",
        // style: { padding: "18px 0 0 0", marginBottom: "15px" },
        // contentClass: "pr-77",
        // rightChildren,
        items: [
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "盘库单号",
            //     disable: true,
            //     fieldName: "stocktakingCode",
            // }, 
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "盘点结果",
                fieldName: "result",
                disable: true,
                allowClear: true,
                showSearch: true,
                options: [{ label: "盘盈", value: "盘盈" }, { label: "盘亏", value: "盘亏" }, { label: "相符", value: "相符" }],

            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "盘点仓库",
                fieldName: "warehouseCode",
                allowClear: true,
                showSearch: true,
                onSelectChange: warehousChange,
                options: transOptions(warehouseList),
                rules: [{ required: true, message: "请选择盘点仓库" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "盘点货位",
                fieldName: "shelfCode",
                allowClear: true,
                showSearch: true,
                mode: "multiple",
                onSelectChange: shelfCode,
                options: transOptions(shelfList),
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "盘点类型",
                allowClear: true,
                showSearch: true,
                options: [{ label: "盘点单", value: "trade-type.stocktaking.stt" }, { label: "期初单", value: "trade-type.stocktaking.init" }],
                fieldName: "type",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "所属站点",
                disable: true,
                fieldName: "shopName",

            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "开始时间",
                showTime: true,
                fieldName: "startTime",
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "结束时间",
                showTime: true,
                fieldName: "endTime",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "制单人员",
                disable: true,
                fieldName: "createUser",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "制单时间",
                disable: true,
                fieldName: "createTime",
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "盘点状态",
                disable: true,
                allowClear: true,
                showSearch: true,
                fieldName: "status",
                options: getSelectedDictOne(DictCodeEnmu.STOCKTAKING),
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "盘库时长",
                fieldName: "duration",
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "仓库名称",
                fieldName: "warehouseName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "完成人",
                disable: true,
                fieldName: "finishUser",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "完成时间",
                disable: true,
                fieldName: "finishTime",
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "审核人",
                disable: true,
                fieldName: "approvalUser",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "审核时间",
                disable: true,
                fieldName: "approvalTime",
            },
        ]
    };

    const onChange = (changedValues: { [key: string]: any }) => {

        if (mode === DetailType.add) {
            updateAddFormVal(changedValues)
        } else if (mode === DetailType.edit) {
            updatEditFormVal(changedValues)
        }
    }
    const typeDesc = {
        add: addDesc,
        edit: editDesc,
        look: lookDesc
    }
    const typeForm = {
        add: { ...detailAddForm, createUser: username, shopId, shopCode, shopName, result: setProfitAndLossForm(typeDesc[mode].differenceNumAll) },
        edit: { ...detailEditForm, result: setProfitAndLossForm(typeDesc[mode].differenceNumAll) },
        look: { ...detailLookForm, result: setProfitAndLossForm(typeDesc[mode].differenceNumAll) }
    }
    const poFromConfig: IYhFormBox = {
        formRef: IFormRef,
        labelCol: { span: 6 },
        labelAlign: "right",
        disabled: mode === DetailType.look || detailEditForm.status === DictCodeEnmu.STOCKTAKING_COMPLETE,
        formValues: { ...typeForm[mode] },
        onChange,
        boxs: [baseFormItem]
    }
    return (
        <>
            <YHDetailNav
                title={
                    <span>
                        盘点单号:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: '#3e67f4' }}>{typeForm[mode].stocktakingCode ?? "暂无"}</span>
                        状态:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: '#3e67f4' }}>{(typeForm[mode]?.status && getTreeNodeName(typeForm[mode]?.status as string)) ?? "暂无"}</span>
                    </span>
                }
                btns={rightChildren}
                style={{ marginBottom: '6px' }}
            />
            <YhFormBox {...poFromConfig} />
        </>
    )
}